// HEADER
//custom announcemnet bar
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = (this.totalPages || 0) - 1;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1], -1)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);
class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider ? this.slider.querySelector('.slideshow__slide') : null;
    if (!this.sliderFirstItemNode) return;

    this.sliderItemsToShow = this.slider ? Array.from(this.slider.querySelectorAll('.slideshow__slide')) : [];
    if (this.sliderItemsToShow && this.sliderItemsToShow.length > 0) {
        this.currentPage = 1;
    }

    this.sliderControlLinksArray = this.sliderControlWrapper ? Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link')) : [];
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    
    if (this.slider) {
        this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    }
    
    this.setSlideVisibility();

    if (this.slider && this.slider.getAttribute('data-autoplay') === 'true') {
        this.setAutoPlay();
    }
    this.extraVisibleElement = 0;
    this.sliderItemsToShow.forEach(ele => {
      if (this.isElementVisible(ele)) this.extraVisibleElement++;
    });
    if (this.extraVisibleElement != 0) this.extraVisibleElement--;
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider?.dataset.speed * 1000 || 5000; // Default to 5000 if undefined

    if (this.sliderAutoplayButton) {
        this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    }
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  isElementVisible(element){
      const rect = element.getBoundingClientRect();
      const rect1 = this.getBoundingClientRect();

      return (
        rect.left >=  rect1.left &&
        rect.right <= rect1.right
      );
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = (this.currentPage + this.extraVisibleElement) === this.sliderItemsToShow.length; // custom code

    if (!isFirstSlide && !isLastSlide) return;
    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition 
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    if (this.currentPage > 0 && this.currentPage <= this.sliderControlButtons.length) {
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    if (this.slider) {
      this.slider.setAttribute('aria-live', 'off');
      clearInterval(this.autoplay);
      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }
  }

  pause() {
    if (this.slider) {
      this.slider.setAttribute('aria-live', 'polite');
      clearInterval(this.autoplay);
    }
  }

  togglePlayButtonState(pauseAutoplay) {
    if (this.sliderAutoplayButton) {
      if (pauseAutoplay) {
        this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
      } else {
        this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
      }
    }
  }

  autoRotateSlides() {
    // custom code
    const slideScrollPosition = (this.currentPage + this.extraVisibleElement) === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    if (!this.slider) return;
    
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');

      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}
customElements.define('slideshow-component', SlideshowComponent);
//custom announcemnet bar

// Mobile Nav toggle open
document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.getElementById('hamburger-toggle');
  const mobileNav = document.getElementById('mobile-menu');
  const htmlElement = document.documentElement;

  mobileNav.classList.add('menu-loaded');
  
  menuToggle.addEventListener('click', function() {
    mobileNav.classList.toggle('active');
    menuToggle.classList.toggle('active');
    menuToggle.classList.toggle('active-close');
    htmlElement.classList.toggle('overflow-hidden');
  });
});

// Header Mobile Menu Accordion

const mobNavAcc = document.getElementsByClassName("accordion-mobile");

for (i = 0; i < mobNavAcc.length; i++) {
  mobNavAcc[i].onclick = function() {

	if( !this.classList.contains('active') ){
    	closeAll();
    }
	
  this.classList.toggle("active");
    const panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  }
  
}

function closeAll(){
	 for (i = 0; i < mobNavAcc.length; i++) {
    	mobNavAcc[i].classList.remove("active");
        mobNavAcc[i].nextElementSibling.style.maxHeight = null;
    }
}

// Tabs

function activateTabs(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-contents");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tab-button");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}

// Localization form JavaScript

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);

// Format Monies

function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

document.addEventListener("DOMContentLoaded", function () {
  const lazyVideos = document.querySelectorAll(".columnVideo");

  if ("IntersectionObserver" in window) {
    const videoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
          const sources = video.querySelectorAll("source");

          // Update each source's `src` attribute from `data-src`
          sources.forEach(source => {
            source.src = source.dataset.src;
          });

          // Load the video
          video.load();

          // Stop observing this video
          observer.unobserve(video);
        }
      });
    });

    // Observe each lazy video
    lazyVideos.forEach(video => {
      videoObserver.observe(video);
    });
  } else {
    // Fallback for browsers without IntersectionObserver support
    lazyVideos.forEach(video => {
      const sources = video.querySelectorAll("source");
      sources.forEach(source => {
        source.src = source.dataset.src;
      });
      video.load();
    });
  }
});



// Global Accordion System
document.addEventListener('DOMContentLoaded', function() {
  const accordionHeaders = document.querySelectorAll('.accordion-header');

  accordionHeaders.forEach(function(header) {
    header.addEventListener('click', function() {
      const accordionItem = header.closest('.accordion-item');
      const content = accordionItem.querySelector('.accordion-content');
      const isOpen = accordionItem.classList.contains('open');

      // Close other open accordions
      document.querySelectorAll('.accordion-item.open').forEach(function(openItem) {
        if (openItem !== accordionItem) {
          closeAccordion(openItem);
        }
      });

      // Toggle current accordion
      if (!isOpen) {
        openAccordion(accordionItem, header, content);
      } else {
        closeAccordion(accordionItem);
      }
    });

    // Keyboard accessibility
    header.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        header.click();
      }
    });
  });

  function openAccordion(item, header, content) {
    item.classList.add('open');
    header.setAttribute('aria-expanded', 'true');
    content.style.maxHeight = content.scrollHeight + "px";
  }

  function closeAccordion(item) {
    item.classList.remove('open');
    const header = item.querySelector('.accordion-header');
    const content = item.querySelector('.accordion-content');
    
    if (header) header.setAttribute('aria-expanded', 'false');
    if (content) content.style.maxHeight = '0';
  }

  // Get the header height and apply the top for product image.
  const headerHeight = getHeight('header');
  const announceMentHeight = getHeight('.announcement-bar-section');
  const totalTop = headerHeight + announceMentHeight;
  const stickyColumn = document.querySelector('#product-template--wrapper .product--medias.relative.product__column-sticky');
   const PopupStickyColumn = document.querySelector('.custom-popup #product-template--wrapper .product--medias.relative.product__column-sticky');
    if (stickyColumn) {
      if (window.innerWidth > 767 && !PopupStickyColumn) {
        stickyColumn.style.top = `${totalTop}px`;
      } else {
        stickyColumn.style.top = `0px`;
      }
    }
  const productWrapper = document.querySelector('#product-template--wrapper.enhanced-product-template');
  const productInfo = document.querySelector('#product-template--wrapper.enhanced-product-template .product-info');
  if(window.innerWidth < 767){
    if (productWrapper) {
      productWrapper.classList.remove('page-width');
    }
    if (productInfo) {
      productInfo.classList.add('page-width');
    }
  } else {
     if (productWrapper) {
      productWrapper.classList.add('page-width');
    }
    if (productInfo) {
      productInfo.classList.remove('page-width');
    }
  }
}); 
// function to get the particular section's height
function getHeight(divClass) {
  const header = document.querySelector(`${divClass}`);
  const headerHeight = header ? header.offsetHeight : 0;
  return headerHeight;
}


//custom sccroll bar for collections list section
window.addEventListener('load', function () {
  const scrollContainer = document.querySelector('.collection-list-grid.scrollable');
  const scrollRange = document.getElementById('scrollRange');

  if (scrollContainer && scrollRange) {
    function updateScrollMax() {
      scrollRange.max = scrollContainer.scrollWidth - scrollContainer.clientWidth;
    }

    updateScrollMax();
    scrollRange.value = scrollContainer.scrollLeft;

    scrollRange.addEventListener('input', () => {
      scrollContainer.scrollLeft = scrollRange.value;
    });

    scrollContainer.addEventListener('scroll', () => {
      scrollRange.value = scrollContainer.scrollLeft;
    });

    window.addEventListener('resize', () => {
      updateScrollMax();
    });
  }
});

// equal height
function setEqualHeights(selector) {
  const elements = document.querySelectorAll(selector);
  let maxHeight = 0;

  // Reset heights first
  elements.forEach(el => {
    el.style.height = 'auto';
  });

  // Find the max height
  elements.forEach(el => {
    const height = el.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  // Apply max height
  elements.forEach(el => {
    el.style.height = maxHeight + 'px';
  });
}

// Run on load
document.addEventListener('DOMContentLoaded', function () {
  setEqualHeights('.product-card-title');
  setEqualHeights('.product-description');
  setEqualHeights('.okeReviews.oke-sr');
  setEqualHeights('.template--product .pdp-key-ingredients .column .column-info h3');
  setEqualHeights('.template--product .custom-steps-section .column .column-info h3');
  setEqualHeights('.template--product .pdp-key-ingredients .column .w-full');
  const buttons = document.querySelectorAll('.button-swatch .swatch_input');
  buttons.forEach(button => {
  button.disabled = false;
});
});

// Run on resize
window.addEventListener('resize', function () {
  setEqualHeights('.product-card-title');
  setEqualHeights('.product-description');
  setEqualHeights('.okeReviews.oke-sr');
  setEqualHeights('.template--product .pdp-key-ingredients .column .column-info h3');
  setEqualHeights('.template--product .custom-steps-section .column .column-info h3');
  setEqualHeights('.template--product .pdp-key-ingredients .column .w-full');
  const headerHeight = getHeight('header');
  const announceMentHeight = getHeight('.announcement-bar-section');
  const totalTop = headerHeight + announceMentHeight;
  const stickyColumn = document.querySelector('#product-template--wrapper .product--medias.relative.product__column-sticky');
   const PopupStickyColumn = document.querySelector('.custom-popup #product-template--wrapper .product--medias.relative.product__column-sticky');
    if (stickyColumn && window.innerWidth > 767 && !PopupStickyColumn) {
    stickyColumn.style.top = `${totalTop}px`;
  } else {
    stickyColumn.style.top = `0px`;
  }
   const productWrapper = document.querySelector('#product-template--wrapper.enhanced-product-template');
  const productInfo = document.querySelector('#product-template--wrapper.enhanced-product-template .product-info');
  if(window.innerWidth < 767){
    if (productWrapper) {
      productWrapper.classList.remove('page-width');
    }
    if (productInfo) {
      productInfo.classList.add('page-width');
    }
  } else {
     if (productWrapper) {
      productWrapper.classList.add('page-width');
    }
    if (productInfo) {
      productInfo.classList.remove('page-width');
    }
  }
});
window.addEventListener('orientationchange', () => {
    const productWrapper = document.querySelector('#product-template--wrapper.enhanced-product-template');
  const productInfo = document.querySelector('#product-template--wrapper.enhanced-product-template .product-info');
  if(window.innerWidth < 767){
    if (productWrapper) {
      productWrapper.classList.remove('page-width');
    }
    if (productInfo) {
      productInfo.classList.add('page-width');
    }
  } else {
     if (productWrapper) {
      productWrapper.classList.add('page-width');
    }
    if (productInfo) {
      productInfo.classList.remove('page-width');
    }
  }
  setTimeout(() => {
    const headerHeight = getHeight('header');
    const announceMentHeight = getHeight('.announcement-bar-section');
    const totalTop = headerHeight + announceMentHeight;

    const stickyColumn = document.querySelector('#product-template--wrapper .product--medias.relative.product__column-sticky');
    const PopupStickyColumn = document.querySelector('.custom-popup #product-template--wrapper .product--medias.relative.product__column-sticky');
    if (stickyColumn && window.innerWidth > 767 && !PopupStickyColumn) {
    stickyColumn.style.top = `${totalTop}px`;
  } else {
    stickyColumn.style.top = `0px`;
  }
  }, 200);
});

const observer = new MutationObserver(() => {
  if (document.querySelector('.okeReviews.oke-sr')) {
    setEqualHeights('.okeReviews.oke-sr');
    observer.disconnect(); // stop watching once done
  }
});
observer.observe(document.body, { childList: true, subtree: true });

//Equal height for rows
function setRowHeights(selector) {
  const elements = Array.from(document.querySelectorAll(selector));
  if (!elements.length) return;

  elements.forEach(el => el.style.height = 'auto');

  let rowTop = 0;
  let rowElements = [];
  let maxHeight = 0;

  elements.forEach(el => {
    const elTop = el.getBoundingClientRect().top;

    if (rowElements.length && elTop !== rowTop) {
      rowElements.forEach(item => item.style.height = maxHeight + 'px');

      rowElements = [];
      maxHeight = 0;
      rowTop = elTop;
    }

    rowElements.push(el);
    maxHeight = Math.max(maxHeight, el.offsetHeight);
    rowTop = rowTop || elTop;
  });
  rowElements.forEach(item => item.style.height = maxHeight + 'px');
}

// Run on load
document.addEventListener('DOMContentLoaded', () => {
  setRowHeights('.template--product .pdp-key-ingredients .column .column-info h3');
  setRowHeights('.template--product .custom-steps-section .column .column-info h3');
});

// Run on resize
window.addEventListener('resize', () => {
  setRowHeights('.template--product .pdp-key-ingredients .column .column-info h3');
  setRowHeights('.template--product .custom-steps-section .column .column-info h3');
});
// works-well-with section Accordion
document.addEventListener("DOMContentLoaded", function() {
  const accordionHeader = document.querySelector(".works-well-with-header");
  const accordionContent = document.querySelector(".complementary-products--wrapper");
  const icon = accordionHeader?.querySelector(".accordion-icon");

  // Assume it's open on page load (since CSS shows it)
  let isOpen = true;

  accordionHeader?.addEventListener("click", function() {
    // Toggle manually using the tracked state
    isOpen = !isOpen;
    accordionContent.style.display = isOpen ? "block" : "none";
    icon.style.transform = isOpen ? "rotate(0deg)" : "rotate(180deg)";
      if (isOpen) { 
        setTimeout(() => {
          setEqualHeights('.product-card-title');
        }, 200);
      }
  });
});


// custom-pdp-accordian section
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pdp-accordion-title').forEach(toggle => {
    if (toggle.dataset.listenerAttached) return;
    toggle.dataset.listenerAttached = "true";

    const item = toggle.closest('.pdp-accordion-item');
    const content = item.querySelector('.pdp-accordion-body');
    const plusIcon = toggle.querySelector('.pdp-accordion-plus');
    const minusIcon = toggle.querySelector('.pdp-accordion-minus');

    if (item.classList.contains('active')) {
      content.style.maxHeight = content.scrollHeight + 'px';
      plusIcon && (plusIcon.style.display = 'none');
      minusIcon && (minusIcon.style.display = 'inline-block');
    } else {
      content.style.maxHeight = '0';
      plusIcon && (plusIcon.style.display = 'inline-block');
      minusIcon && (minusIcon.style.display = 'none');
    }

    toggle.addEventListener('click', function () {
      const expanded = item.classList.contains('active');

      document.querySelectorAll('.pdp-accordion-item').forEach(el => {
        if (el !== item) {
          el.classList.remove('active');
          const elContent = el.querySelector('.pdp-accordion-body');
          const elPlus = el.querySelector('.pdp-accordion-plus');
          const elMinus = el.querySelector('.pdp-accordion-minus');
          elContent && (elContent.style.maxHeight = '0');
          elPlus && (elPlus.style.display = 'inline-block');
          elMinus && (elMinus.style.display = 'none');
        }
      });

      item.classList.toggle('active');
      if (!expanded) {
        content.style.maxHeight = content.scrollHeight + "px";
        plusIcon && (plusIcon.style.display = 'none');
        minusIcon && (minusIcon.style.display = 'inline-block');
      } else {
        content.style.maxHeight = "0";
        plusIcon && (plusIcon.style.display = 'inline-block');
        minusIcon && (minusIcon.style.display = 'none');
      }
    });
  });
  //custom-pdp-popup
  if (!document.body.classList.contains('template--product')) return;
  const productHasFormulaOption = document.querySelector('.choose-formula-variant');
  if (!productHasFormulaOption) return;
  
  const openPopup = document.querySelector('.open-popup');
  const popup = document.querySelector('.pdp-custom-popup');
  const closePopup = document.querySelector('.custom-popup-close');
  const overlay = document.querySelector('.custom-popup-overlay');

  if (openPopup && popup) {
    openPopup.addEventListener('click', (e) => {
      e.preventDefault();
      popup.style.display = 'flex';
    });

    [closePopup, overlay].forEach(el => {
      if (el) el.addEventListener('click', () => popup.style.display = 'none');
    });
  }
});
// custom-pdp-accordian section

// Subscription option change price
const container = document.querySelector('.bsub-widget__delivery-fieldset');
if (container) {
  container.addEventListener('click', (event) => {
    if (event.target.matches('.bsub-option-container input[type="radio"]')) {
      const currentInput = event.target;
      const priceElement = currentInput
        .closest('.bsub-option-container')
        ?.querySelector('.bsub-widget__plan-header .bsub-widget__plan-pricing span[data-bsub-per-delivery-price]');
      if (priceElement) {
        const secletedPrice = priceElement.textContent.trim();
        document.querySelector('.price').textContent = secletedPrice.replace(/\.00$/, '');
        document.querySelector('.sticky-price').textContent = secletedPrice.replace(/\.00$/, '');
      }
    }
  });
}

// Subscription details
document.querySelectorAll('input[name="bsub-selling-plan-group"]').forEach((radio) => {
  radio.addEventListener('change', (event) => {
    const wrapper = event.target.closest('.bsub-widget__wrapper');
    const childContainer = wrapper.querySelector('.bsub-options-container');
    if (childContainer) {
      if (!childContainer.classList.contains('bsub__hidden')) {
        const selectedOPtionPrice = childContainer.querySelector(`.bsub-options-container .bsub-widget__delivery-fieldset .bsub-option-container input:checked + .bsub-widget__plan-header .bsub-widget__plan-pricing span[data-bsub-per-delivery-price]`);
        if (selectedOPtionPrice) {
          const priceText = selectedOPtionPrice.textContent.trim();
          document.querySelector('.price').textContent = priceText.replace(/\.00$/, '');
          document.querySelector('.sticky-price').textContent = priceText.replace(/\.00$/, '');
        }
        const metafieldInput = document.getElementById('subs-hidden_data');
        if (metafieldInput == null) return;
        const metafieldData = metafieldInput?.getAttribute('data-metafield')?.trim();
        const splitData = metafieldData ? metafieldData.split('&##').map((text) => text.trim()) : [];
        const paragraphs = document.querySelectorAll('.custom-text_container p');
        paragraphs.forEach((p, index) => {
          if (splitData[index] && splitData[index] !== "") {
            p.textContent = splitData[index];
          }
        });
      } else {
        let selectedOptions = [];
        document.querySelectorAll('.option-wrapper input[type="radio"]:checked + .variant-swatche_parent .variant-pice').forEach((radio) => {
          selectedOptions.push(radio.value);
        });
        const defaultPrice = document.querySelector('.option-wrapper input[type="radio"]:checked + .variant-swatche_parent .variant-pice');
        if (defaultPrice) {
          const priceText = defaultPrice.textContent.trim();
          document.querySelector('.price').textContent = priceText.replace(/\.00$/, '');
          document.querySelector('.sticky-price').textContent = priceText.replace(/\.00$/, '');
        }
        const metafieldInput = document.getElementById('non-subs-hidden-data');
        const metafieldData = metafieldInput?.getAttribute('data-metafield')?.trim();
        const splitData = metafieldData ? metafieldData.split('&##').map((text) => text.trim()) : [];
        const paragraphs = document.querySelectorAll('.custom-text_container p');
        paragraphs.forEach((p, index) => {
          if (splitData[index] && splitData[index] !== "") {
            p.textContent = splitData[index];
          }
        });
      }
    }
  });
});


//PDP Sticky Add To Cart 
document.addEventListener("DOMContentLoaded", function () {
  const stickyBar = document.getElementById("sticky-add-to-cart");
  if (!stickyBar) return;

  const mainATCForm = document.querySelector("form[action='/cart/add'] #product-form") || document.querySelector("form[action='/cart/add']");
  if (!mainATCForm) return;

  // Show/hide sticky bar based on scroll position
  const toggleStickyBar = () => {
    const rect = mainATCForm.getBoundingClientRect();
    const isOutOfView = rect.bottom < 0;
    
    if (isOutOfView) {
      stickyBar.classList.remove("hidden");
    } else {
      stickyBar.classList.add("hidden");
    }
  };

  // Initial check in case the form is already out of view
  toggleStickyBar();

  // Update sticky bar on scroll
  window.addEventListener("scroll", toggleStickyBar);
  const stickyText = document.getElementById("sticky-add-to-cart-text");
  // Scroll to main Add to Cart form when sticky is clicked
  if (stickyText) {
    stickyText.addEventListener("click", () => {
      mainATCForm.scrollIntoView({
        behavior: "smooth",
        block: "center", // or "start" if you want it higher up
      });
    });
     }
});

